import { addToCart, debounce } from '@nova/utils'

class ProductCard extends HTMLElement {
  constructor() {
    super()

    this.colorGrey400 = '#686C6D'
    this.colorMaroon = '#922C20'

    this.$atc = this.querySelector('.js-product-card-atc')
    this.$quickViewBtn = this.querySelector('.js-product-card-qv')
    this.$quickViewDialog = this.querySelector('.product-card-dialog')
    this.displayDeliveryDates = this.querySelector('[display-delivery-dates]').value === 'true'
    this.messageProperty = this.querySelector('[display-delivery-dates]').dataset.message

    this.handleAddToCartClick = this.handleAddToCartClick.bind(this)
    this.handleQuickViewClick = this.handleQuickViewClick.bind(this)
    this.checkDisabledNavigation = this.checkDisabledNavigation.bind(this)
    this.debouncedOnSlideChange = debounce(this.checkDisabledNavigation, 100)
  }

  connectedCallback() {
    this.gallery = this.querySelector('.product-card-gallery__carousel')

    this.$atc.addEventListener('click', this.handleAddToCartClick)
    this.$quickViewBtn.addEventListener('click', this.handleQuickViewClick)
    this.gallery.addEventListener('sl-slide-change', this.debouncedOnSlideChange)

    this.debouncedOnSlideChange()
  }

  disconnectedCallback() {
    this.$atc.removeEventListener('click', this.handleAddToCartClick)
    this.$quickViewBtn.removeEventListener('click', this.handleQuickViewClick)
  }

  changeTimeZone(date, timeZone) {
    if (typeof date === 'string') {
      return new Date(
        new Date(date).toLocaleString('en-US', {
          timeZone,
        }),
      )
    }

    return new Date(
      date.toLocaleString('en-US', {
        timeZone,
      }),
    )
  }

  async handleAddToCartClick(e) {
    try {
      const properties = {}
      const variantId = e.target.dataset.variantId
      const hideQty = e.target.dataset.hideQty
      if (hideQty === 'true') {
        properties['_hide_qty_selector'] = 'true'
      }

      if(this.displayDeliveryDates) {
        const localDate = new Date()
        const timeZone = 'America/New_York'
        const estTime = this.changeTimeZone(localDate, timeZone)
        const timeArr = estTime.toString().split(' ')
        const date = timeArr[0].toLowerCase()
        const hour = Number(timeArr[4].split(':')[0])

        const startDay = new Date()
        const endDay = new Date()
        if(date != 'mon') {
          startDay.setDate(startDay.getDate() + (((3 + 7 - startDay.getDay()) % 7) || 7))
        } else if(hour < 17) {
          startDay.setDate(startDay.getDate() + 2)
        } else {
          startDay.setDate(startDay.getDate() + (((3 + 7 - startDay.getDay()) % 7) || 7))
        }
        endDay.setDate(startDay.getDate() + 2)
        const messageDates = `${startDay.getMonth() + 1}/${startDay.getDate()}-${endDay.getMonth() + 1}/${endDay.getDate()}`
        properties[this.messageProperty] = messageDates
      }

      const param = { id: variantId, properties }

      await addToCart(param)
    } catch (error) {
      console.error(error)
    }
  }

  handleQuickViewClick(e) {
    e.preventDefault()
    this.$quickViewDialog.show()
  }

  checkDisabledNavigation (index = 0, slide = null) {
    const navButtons = [...this.gallery.shadowRoot?.querySelectorAll('.carousel__navigation-button')] || []
    navButtons.forEach(item => {
      if(item.getAttribute('aria-disabled') === 'true') {
        item.style.background = this.colorGrey400
      } else {
        item.style.background = this.colorMaroon
      }
    })
  }
}

customElements.define('product-card', ProductCard)
